import React from 'react'
import HomeBody from '../Components/HomeBody/HomeBody'
import Footer from '../Components/Footer/Footer'
//import ChatBot from '../Components/Chat/ChatBot'
//import Chat from '../Components/Chat/Chat'

function Home() {
    return (
        <>
        <HomeBody>
            
        </HomeBody>
        
        <Footer/>

        {/* <Chat/> */}
        {/* <ChatBot/> */}
        </>
    )
}

export default Home
